import { useEffect, useState } from "react";
import { progressStore } from "./progress-store";

/**
 * Hydrate the shared /learner/progress blob once on mount and re-render when it
 * arrives. Returns true once the store has been hydrated so callers can gate
 * progress UI (avoids an empty→filled flash). The store is a singleton, so a
 * second mount that finds it already hydrated resolves immediately.
 */
export function useProgressHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    void progressStore.hydrate().then(() => setHydrated(true));
  }, []);
  return hydrated;
}
